<template>
  <div class="page-content schedule-recurring-payment">

    <!-- BREADCRUMB -->
    <f-p-breadcrumb
      :breadcrumbOuter="$lang.messages.payments.toUpperCase()"
      :breadcrumbTo="'Recurring'"
      :breadcrumbToTitle="$lang.messages.recurring"
      :breadcrumbInner="$lang.messages.bb_sharedExpense.toUpperCase()"
      :breadcrumbIsHistory="false">
    </f-p-breadcrumb>

    <div class="page-wrapper">
      <fp-schedule-recurring-payment
        :type="type"
        :guid="guid"
        :bluredProp="bluredProp"
        @clearInputErrorsPayments="clearInputErrorsPayments"
        @clearOthersPayments="clearOthersPayments"
        @checkAnyInput="checkAnyInput"
      >
      </fp-schedule-recurring-payment>
    </div>

  </div>
</template>

<script>
  import FpScheduleRecurringPayment from '@/components/common/FPScheduleRecurringPayment';
  import FPBreadcrumb from "@/components/common/FPBreadcrumb";

  export default {
    name: "sharedExpensesScheduleRecurringPayment",
    components: {
      FpScheduleRecurringPayment,
      'f-p-breadcrumb': FPBreadcrumb
    },
    props: {
      bluredProp: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        type: this.$SHARED_EXPENSE_TYPE,
        guid: this.$route.params.id,
      };
    },
    methods: {
      clearInputErrorsPayments (e) {
        this.$emit('clearInputErrorsPayments', e)
      },
      clearOthersPayments (e) {
        this.$emit('clearOthersPayments', e)
      },
      checkAnyInput () {
        this.$emit('checkAnyInput')
      }
    }
  };
</script>
